module.exports = __webpack_public_path__ + "media/50.d4903247.mp3";